import React from 'react';
import { hot } from 'react-hot-loader';
import { purifier } from '../../utils/dom';

const StructuredData = ({ canonical, product, soldOut, price = {}, currency, image }) => {
	const jsonData = {
		'@context': 'http://schema.org',
		'@type': 'Product',
		url: canonical,
		name: product.name,
		brand: {
			'@type': 'Brand',
			name: product.brandName,
		},
		sku: product.sku,
		description: product.metaDescription,
		image,
		offers: {
			'@type': 'Offer',
			availability: (soldOut ? 'https://schema.org/OutOfStock' : 'http://schema.org/InStock'),
			price: price.priceAsNumber,
			priceCurrency: currency,
			url: canonical,
		},
	};

	return (
		<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: purifier(JSON.stringify(jsonData), { ALLOWED_TAGS: [] }) }} />
	);
};

export default hot(module)(StructuredData);
